import { useModalStore } from "@/store/modal";

export default {
  install(app) {
    const modalStore = useModalStore();
    app.config.globalProperties.$alert = modalStore.showAlertModal;
    app.config.globalProperties.$confirm = modalStore.showConfirmModal;
    app.config.globalProperties.$closeConfirm = modalStore.closeConfirm;
    app.config.globalProperties.$closeAlert = modalStore.closeAlert;
  },
};
